module.exports = __webpack_public_path__ + "img/07.10ab1b7f.png";